// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const linussLaw: Law = {
  slug: "linuss-law",
  title: "Linus's Law",
  definition: "Given enough eyeballs, all bugs are shallow.",
  category: "theory",
  color: "#ad65be",
  labels: ["cs","software-engineering"],
  copy: ["Named after Linus Torvalds, the creator of Linux, this law states:","This law was described using the famous The Cathedral and the Bazaar essay, explaining the contrast between two different free software development models:","The conclusion? The more widely available the source code is for public testing, scrutiny, and experimentation, the more rapidly all forms of bugs will be discovered."],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
